export enum DISCUSSION {
  QUESTIONS = 'questions',
  REVIEWS = 'reviews',
}

export enum DEAL_COMMENT_TYPE {
  REVIEW = 'dealreview',
  QUESTION = 'dealcomment',
}
